<template>
  <div id="page-forms">
    <v-toolbar
      card
      dense
      color="transparent"
    >
      <!-- <v-toolbar-title><h4>Details</h4></v-toolbar-title> -->
      <v-btn
        color="primary"
        outline
      >Save & Close</v-btn>

      <v-btn icon>
        <v-icon>reply</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>delete</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>first_page</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>last_page</v-icon>
      </v-btn>
      <v-menu
        bottom
        left
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(item, i) in items"
            :key="i"
            click
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <!-- <v-spacer></v-spacer> <v-btn color="primary" outline>Post</v-btn> -->
    </v-toolbar>
    <v-container fluid>
      <v-form
        v-model="valid"
        ref="form"
        lazy-validation
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            lg4
            sm4
          >

            <v-text-field
              label="Date"
              prepend-icon="calendar_today"
              name="date"
              v-model="form.date"
            >
            </v-text-field>

          </v-flex>
          <v-flex
            lg4
            sm4
          >

            <v-text-field
              label="Login User"
              prepend-icon="person"
              name="user"
              v-model="form.userName"
            >
            </v-text-field>

          </v-flex>
          <v-flex
            lg1
            sm2
          ></v-flex>
          <v-flex
            lg3
            sm2
          >
            <p>
              <v-icon>verified_user</v-icon>&nbsp;&nbsp;Is this your name?
            </p>
            <v-radio-group
              v-model="form.login"
              row
            >
              <v-radio
                label="Yes"
                value="yes-1"
              ></v-radio>
              <v-radio
                label="No"
                value="No-1"
              ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex
            lg6
            sm6
          >

            <v-menu
              class="pr-2"
              ref="startDate"
              lazy
              :close-on-content-click="false"
              v-model="startDateMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-22"
              max-width="290px"
              :return-value.sync="startDate"
            >
              <v-text-field
                slot="activator"
                label="Start Date"
                v-model="form.startDate"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="startDate"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  color="primary"
                  @click="startDateMenu = false"
                >Cancel</v-btn>
                <v-btn
                  flat
                  color="primary"
                  @click="$refs.startDate.save(startDate)"
                >OK</v-btn>
              </v-date-picker>
            </v-menu>

          </v-flex>
          <v-flex
            lg6
            sm6
          >
            <v-menu
              class="pr-2"
              ref="endDate"
              lazy
              :close-on-content-click="false"
              v-model="startDateMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-22"
              max-width="290px"
              :return-value.sync="endDate"
            >
              <v-text-field
                slot="activator"
                label="Finish Date"
                v-model="form.endDate"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="endDate"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  color="primary"
                  @click="startDateMenu = false"
                >Cancel</v-btn>
                <v-btn
                  flat
                  color="primary"
                  @click="$refs.endDate.save(endDate)"
                >OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex
            lg6
            sm6
          >
            <v-autocomplete              
              hint="Atleast 3 Characters required"              
              :loading="loader"              
              flat
              placeholder="Select only suggested Production Order"
              :items="cardTypes"
              v-model="form.cardTypeId"
              label="Production Order"
              auto
              chips
              prepend-icon="add_shopping_cart"
              required
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            lg12
            sm12
          >
            <production-line></production-line>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>
 <script>
import ProductionLine from '@/components/widgets/list/ProductionLines';
export default {
  components: {
    ProductionLine
  },
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    saveCard: true,
    items: [
      { title: 'Clear Items' },
      { title: 'Post Journal' },
      { title: 'Delete' }
    ],
    cardTypes: [
      {
        id: 1,
        name: 'RPO-2018-0023'
      },
      {
        id: 2,
        name: 'RPO-2018-0024'
      }
    ],
    valid: true,
    form: {
      cardNumber: 'SW Task',
      cardTypeId: 1,
      startDate: '2018-04-09',
      endDate: '2018-04-09',
      date: '2018-04-09',
      login: 'yes-1',
      userName: 'SW Task'
    }
  }),
  mounted () {
    this.$validator.localize('en', this.dictionary);
  },

  methods: {
    submit () {
      this.$validator.validateAll();
    },
    clear () {
      this.form = {};
      this.$validator.reset();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/scrap/ProductionScrapJournal.vue